/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Picker_Hint_MultipleInputs */

const vi_media_picker_hint_multiple = /** @type {(inputs: Media_Picker_Hint_MultipleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bấm để chọn nhiều ảnh rồi bấm Chọn; ảnh vừa tải lên được chọn sẵn.`)
};

/**

* @param {Media_Picker_Hint_MultipleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_picker_hint_multiple = /** @type {((inputs?: Media_Picker_Hint_MultipleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Picker_Hint_MultipleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_picker_hint_multiple(inputs)
});